import { render, staticRenderFns } from "./MobileCommunityUnitBusinessNewsReply.vue?vue&type=template&id=c00f8e00&"
import script from "./MobileCommunityUnitBusinessNewsReply.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityUnitBusinessNewsReply.vue?vue&type=script&lang=js&"
import style0 from "./MobileCommunityUnitBusinessNewsReply.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports